import React from 'react';
import smallX from '../../../../images/icons/X-small.png';
import CartSiblings from './cart-siblings';

import './cart-siblings-modal.scss';

const CartSiblingsModal = ({
  logoMap,
  params,
  product,
  pubId,
  scrollable,
  trackLinkOut,
  currentDateRange,
  closeModal,
}) => {
  return (
    <div className="cart-siblings-modal-container" onClick={closeModal}>
      <div className="cart-siblings-modal modal movable-right" onClick={e => e.stopPropagation()}>
        <img src={smallX} className="close" alt="close" onClick={closeModal} />
        <CartSiblings
          logoMap={logoMap}
          params={params}
          product={product}
          pubId={pubId}
          scrollable={scrollable}
          trackLinkOut={trackLinkOut}
          currentDateRange={currentDateRange}
          type="product-research"
        />
      </div>
    </div>
  );
};

export default CartSiblingsModal;
